import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import AgentCapabilities from "@/components/AgentCapabilities";
import UseCases from "@/components/UseCases";
import Collections from "@/components/Collections";
import HowItWorks from "@/components/HowItWorks";
import AdminRoles from "@/components/AdminRoles";
import Security from "@/components/Security";
import HonestList from "@/components/HonestList";
import Languages from "@/components/Languages";
import WhoItsFor from "@/components/WhoItsFor";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <AgentCapabilities />
        <UseCases />
        <Collections />
        <HowItWorks />
        <AdminRoles />
        <Security />
        <div id="honest-list">
          <HonestList />
        </div>
        <Languages />
        <div id="get-started">
          <WhoItsFor />
        </div>
        <Faq />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
